import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import useTheme from "./useTheme";

const AddModir = (props) => {
  const [showAdd, setShowAdd] = useState(false);

  const [mobileInput, setMobileInput] = useState("");

  const [showDel, setShowDel] = useState(false);

  const [showRes, setShowRes] = useState(false);

  const [res, setRes] = useState("");

  const [mobile, setMobile] = useState("");

  const [theme, switchTheme] = useTheme();

  useEffect(() => {
    const form = new FormData();
    form.append("getKarmand", 1);
    form.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setMobile(data.data);
        console.log(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [showRes]);

  const mobileHandle = (e) => {
    if (isNaN(e.target.value)) {
      return;
    } else {
      setMobileInput(e.target.value);
    }
  };

  const addModir = () => {
    if (mobileInput[0] + mobileInput[1] !== "09" || mobileInput.length !== 11) {
      alert("شماره وارد شده اشتباه است");
      return;
    }
    if (mobileInput === mobile) {
      alert("شماره وارد شده تکراری است");
      return;
    }
    const form = new FormData();
    form.append("addModir", 1);
    form.append("vitrinCode", props.vitrinCode);
    form.append("mobile", mobileInput);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setRes(data.data);
        setShowRes(true);
        console.log(data);
      })
      .catch((e) => {
        console.log(e);
        setShowRes(true);
        setRes("اشکال در برقراری ارتباط با سرور");
      });
  };

  const del = () => {
    const form = new FormData();
    form.append("delKarmand", 1);
    form.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setRes(data.data);
        setShowRes(true);
        console.log(data);
      })
      .catch((e) => {
        console.log(e);
        setShowRes(true);
        setRes("اشکال در برقراری ارتباط با سرور");
      });
  };

  return (
    <div>
      <Nav.Link
        onClick={() => {
          setShowAdd(true);
        }}
        href="#"
        className={theme === "light" ? "text-dark" : "text-light"}
      >
        افزودن مدیر
      </Nav.Link>

      <Modal
        show={showAdd}
        onHide={() => {
          setShowAdd(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          افزودن مدیر
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {mobile !== "" ? (
            <div>
              <p>
                <span className="mr-2">
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => {
                      setShowDel(true);
                    }}
                  >
                    حذف
                  </button>
                </span>
                مدیر دوم فعلی : <span className="text-muted">{mobile}</span>
              </p>
            </div>
          ) : null}
          <div className="mt-3 text-center">
            <div className="form-lable">موبایل مدیر دوم</div>
            <input
              className="form-control mt-1"
              value={mobileInput}
              onChange={mobileHandle}
              maxLength="11"
            />
            <button className="btn btn-success mt-2" onClick={addModir}>
              ثبت
            </button>
          </div>
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowAdd(false);
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDel}
        onHide={() => {
          setShowDel(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          آیا از حذف مدیر مطمئن هستید؟
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-success"
            onClick={() => {
              del();
            }}
          >
            بله
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              setShowDel(false);
            }}
          >
            خیر
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRes}
        onHide={() => {
          setShowRes(false);
          setShowDel(false);
          setMobileInput("");
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {res}
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowRes(false);
              setShowDel(false);
              setMobileInput("");
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddModir;
